import { Flex, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const Loading: React.FC = () => {
  return (
    <div className="w-full h-screen border-mx-auto flex justify-center items-center">
      <Flex align="center" gap="middle">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      </Flex>
    </div>
  );
};
